import { Link } from "react-router-dom";

export default function NoteLegali() {
  return (
    <div className="pt-32 md:pt-40 pb-16 px-6 md:px-10" data-testid="note-legali-page">
      <div className="max-w-3xl mx-auto">
        <p className="text-[10px] uppercase tracking-[0.4em] text-[#FF2768] mb-4">— Impressum</p>
        <h1 className="font-display text-6xl md:text-8xl text-[#3D2140] leading-[0.9] mb-12">Note Legali</h1>

        <div className="space-y-6 text-[#3D2140]/85 leading-relaxed text-base">
          <h2 className="font-display text-4xl text-[#3D2140]">Dati dell'attività</h2>
          <div className="bg-[#81C3C9]/15 rounded-2xl p-6 space-y-2">
            <p><strong>Titolare:</strong> Teresa Vilardo</p>
            <p><strong>Attività:</strong> Educatrice nei servizi per l'infanzia · Family Coach Montessori · Educatrice neonatale · Consulente in Puericultura 0–36 mesi</p>
            <p><strong>Partita IVA:</strong> 04179511201</p>
            <p><strong>Sito web:</strong> www.teresavilardo.it</p>
            <p><strong>Email istituzionale:</strong> <a href="mailto:teresa.vilardo84@live.it" className="text-[#FF2768] link-underline">teresa.vilardo84@live.it</a></p>
            <p><strong>Email professionale:</strong> <a href="mailto:teresavilardoconsulente@gmail.com" className="text-[#FF2768] link-underline">teresavilardoconsulente@gmail.com</a></p>
            <p><strong>WhatsApp:</strong> +39 340 399 3522</p>
          </div>

          <h2 className="font-display text-4xl text-[#3D2140] pt-8">Marchi e proprietà intellettuale</h2>
          <p>I nomi <strong>Metodo T.A.T.A.®</strong>, <strong>Protocollo T.A.T.A.®</strong>, <strong>Modello Educativo T.A.T.A.®</strong> e <strong>T.A.T.A. Academy</strong>, insieme al logo con orsetto, sono di proprietà esclusiva di Teresa Vilardo. Tutti i contenuti pubblicati (testi, immagini, illustrazioni, layout, materiali formativi) sono protetti dalle vigenti normative sul diritto d'autore (L. 633/1941 e successive modifiche).</p>
          <p>È vietata la riproduzione, distribuzione, modifica o utilizzo commerciale — anche parziale — senza previa autorizzazione scritta del Titolare.</p>

          <h2 className="font-display text-4xl text-[#3D2140] pt-8">Limitazioni di responsabilità</h2>
          <p>Il sito ha finalità informative ed educative. Le informazioni fornite non sostituiscono in alcun modo il parere del pediatra, del medico o di altri professionisti sanitari qualificati. In caso di problemi di salute del bambino o di dubbi clinici, consultare sempre il proprio pediatra.</p>

          <h2 className="font-display text-4xl text-[#3D2140] pt-8">Link esterni</h2>
          <p>Questo sito può contenere link a siti terzi (Google Forms, JotForm, Calendly, Spotify, Instagram, Adobe). Il Titolare non è responsabile dei contenuti né delle politiche di privacy dei siti terzi.</p>

          <h2 className="font-display text-4xl text-[#3D2140] pt-8">Documenti correlati</h2>
          <p>
            <Link to="/privacy" className="text-[#FF2768] link-underline">Privacy Policy</Link> · <Link to="/cookie-policy" className="text-[#FF2768] link-underline">Cookie Policy</Link> · <Link to="/termini" className="text-[#FF2768] link-underline">Termini di Servizio</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
